import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { FormComponent, ToastService } from '../../../../shared/components';
import {
  CitiesApiClientProvider,
  CreateDistrictModel,
  defaultPaginationParameters,
  DistrictsApiClientProvider,
  ErrorOrError,
  handleApiErrors,
  ICityResponse,
  ICreateDistrictRequest,
  ICreateDistrictResponse,
  IPaginationResponse,
  Logger,
  UpdateDistrictModel
} from '../../../../../common';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subscription, Observable } from 'rxjs';
import { FormInputConfig, ListValues } from '../../../../shared/interfaces/form-input-config';

@Component({
  selector: 'app-create-update-district',
  imports: [ReactiveFormsModule, DialogModule, CommonModule, FormComponent, TranslateModule],
  templateUrl: './create-update-district.component.html',
  styleUrl: './create-update-district.component.scss'
})
export class CreateUpdateDistrictComponent {
  private client = inject(DistrictsApiClientProvider).getClient();
  private clientCities = inject(CitiesApiClientProvider).getClient();
  private toastService = inject(ToastService);
  private cdr = inject(ChangeDetectorRef);
  private dialogRef = inject(DynamicDialogRef);
  private translate = inject(TranslateService);
  modalData = inject(DynamicDialogConfig);
  private subscriptions: Subscription[] = [];
  formConfigs: FormInputConfig[] = [];
  isLoadingAddEditItem = false;
  itemsFormValidationEmit = false;
  validationErrors = {};
  itemId: string = '';
  model: UpdateDistrictModel = CreateDistrictModel.createDefault();
  cities: ListValues[] = [];

  ngOnInit(): void {
    this.itemId = this.modalData?.data?.item?.id ?? '';
    this.initializeItemData();
    this.getCities();
  }
  private initializeItemData(): void {
    const item = this.modalData?.data?.item;
    if (item) {
      this.model = UpdateDistrictModel.createFromItem(item);
    }
  }
  private initForm(): void {
    this.formConfigs = this.model.getFormConfig(this.cities, this.modalData?.data?.visible, this.translate);
  }

  getCities(keyword?: string) {
    this.clientCities.get(defaultPaginationParameters).subscribe({
      next: (res: IPaginationResponse<ICityResponse>) => {
        this.processCitiesListResponse(res), this.initForm();
      },
      error: (errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)
    });
  }
  private processCitiesListResponse(response: IPaginationResponse<ICityResponse>): void {
    const items: ICityResponse[] = response.items ?? [];
    this.cities = items.map((item: ICityResponse) => ({
      // label: item.englishName,
      label: this.translate.currentLang === 'ar' ? item.arabicName : item.englishName,
      value: item.id
    }));
  }

  formValuesChanged(data: any): void {
    Logger.debug('formValuesChanged:', data);
  }
  async submitForm(request: ICreateDistrictRequest): Promise<void> {
    Logger.debug('Submit form:', request, this.model);
    this.isLoadingAddEditItem = true;
    this.cdr.detectChanges();
    const request$: Observable<void | ICreateDistrictResponse> = this.model.id
      ? this.client.update(this.itemId, request)
      : this.client.create(request);
    request$.subscribe({
      next: (response) => this.handleActionSuccess(response),
      error: (errors) => this.handleActionError(errors),
      complete: () => this.finalizeAction()
    });
  }
  private handleActionSuccess(response: ICreateDistrictResponse | void): void {
    const successTitle = this.translate.instant('GENERAL.SUCCESS');
    const message = response
      ? this.translate.instant('GENERAL.SUCCESSFULLY_CREATED')
      : this.translate.instant('GENERAL.SUCCESSFULLY_UPDATED');
    this.toastService.showSuccess(successTitle, message);
    this.cdr.detectChanges();
    this.onClose(response ?? true);
  }
  private handleActionError(errors: ErrorOrError[]): void {
    Logger.debug('Action Error:', errors);
    if (this.toastService) {
      handleApiErrors(errors, this.toastService);
    }
    this.isLoadingAddEditItem = false;
  }
  private finalizeAction(): void {
    this.isLoadingAddEditItem = false;
    this.itemsFormValidationEmit = false;
  }
  emitValidation(): void {
    this.itemsFormValidationEmit = !this.itemsFormValidationEmit;
    this.cdr.detectChanges();
  }
  onClose(data?: boolean | ICreateDistrictResponse): void {
    this.dialogRef.close(data);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      if (sub && !sub.closed) {
        sub.unsubscribe();
      }
    });
  }
}
